module.exports = __webpack_public_path__ + "static/media/italic.0f5e1187.svg";